import React, { FC } from 'react';
import classNames from 'classnames';
import { IconProps } from './type';

export const IconCheckmarkCircle: FC<React.PropsWithChildren<IconProps>> = ({ className, width = 24, height = 24 }) => (
  <svg className={classNames([className])} width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1594_4609)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        // eslint-disable-next-line max-len
        d="M3 12C3 7.03 7.03 3 12 3C16.97 3 21 7.03 21 12C21 16.97 16.97 21 12 21C7.03 21 3 16.97 3 12ZM5 12C5 15.86 8.14 19 12 19C15.86 19 19 15.86 19 12C19 8.14 15.86 5 12 5C8.14 5 5 8.14 5 12ZM8.71005 10.8L11 13.09L15.3101 8.80005L16.72 10.21L11.72 15.21C11.52 15.4 11.27 15.5 11.01 15.5C10.75 15.5 10.5 15.41 10.3 15.21L7.30005 12.21L8.71005 10.8Z"
        fill="#005AD9"
      />
    </g>
    <defs>
      <clipPath id="clip0_1594_4609">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
